import Http from "../helpers/Http";


class TaxDataService {
  getAll() {
    return Http.get("/taxes");
  }

  get(id) {
    return Http.get(`/taxes/${id}`);
  }

  create(data) {
    return Http.post("/taxes",data);
  }

  update(data) {
    return Http.update("/taxes",data);
  }

}

export default new TaxDataService();